export enum PublishingRuleViolationVisibility {
	INVALID = "INVALID",
	INVALID_PREVIEW = "INVALID_PREVIEW",
	PREVIEW = "PREVIEW",
	VISIBLE_IN_SEARCH = "VISIBLE_IN_SEARCH",
}

export interface PublishingRuleViolationsView {
	canEditImages: boolean
	canEditPrice: boolean
	canEditStocknumber: boolean
	errors: PublishingRuleViolation[]
	marketToCustomers?: boolean
	visibility: PublishingRuleViolationVisibility
	warnings: PublishingRuleViolation[]
}

export type PublishingRuleKey =
	| "four-images-required"
	| "seller-email-and-phone-required"
	| "tyre-label-information-required"
	| "recycle-fee-type-required"
	| "commercial-register-number-required"
	| "registration-date-required"
	| "seller-fee-payment-required"
	| "swiss-EEL-data-required"
	| "german-EEL-data-required"
	| "french-EEL-data-required"
	| "consumption-emission-for-new-cars-required"
	| "transmission-required"
	| "stock-number-required"
	| "stock-number-or-commission-number-required"
	| "price-required"
	| "price-breakdown-required-for-new-cars"
	| "interior-color-required"
	| "exterior-color-required"
	| "rooftop-color-required"
	| "power-required"
	| "order-type-code-required"
	| "used-condition-required"
	| "end-of-press-embargo-required"
	| "vin-required"
	| "v200-required"
	| "unknown-error"

type PublishingRuleSeverity = "warning" | "error"

export interface PublishingRuleViolation {
	message: string
	name: PublishingRuleKey
	severity: PublishingRuleSeverity
}
